export const aplicarFocoContinuo = async (track) => {
  if (!track?.getCapabilities?.().focusMode?.includes("continuous")) return;
  await track
    .applyConstraints({ advanced: [{ focusMode: "continuous" }] })
    .catch(() => {});
};
